import React, { useState } from 'react';
import { Table, Card, Tag, Button, Space, Badge, Modal, Form, Input, Select, message, Row, Col, Statistic } from 'antd';
import { PlusOutlined, FileTextOutlined } from '@ant-design/icons';

const orders = [
  { key: '1', id: 'WO-2031', title: '卡片无法激活', client: '深圳割草机科技', type: 'activation', priority: 'high', status: 'pending', time: '2026-03-13 15:30', handler: '' },
  { key: '2', id: 'WO-2030', title: '流量套餐变更申请', client: '广州CPE公司', type: 'package', priority: 'normal', status: 'processing', time: '2026-03-13 11:20', handler: '张工' },
  { key: '3', id: 'WO-2029', title: '批量停机请求', client: '北京VR体验馆', type: 'operation', priority: 'normal', status: 'done', time: '2026-03-12 16:45', handler: '李工' },
  { key: '4', id: 'WO-2028', title: 'eSIM切换失败', client: '上海安防', type: 'esim', priority: 'high', status: 'processing', time: '2026-03-12 10:10', handler: '王工' },
  { key: '5', id: 'WO-2027', title: '账单对账问题', client: '成都对讲机', type: 'billing', priority: 'low', status: 'done', time: '2026-03-11 14:22', handler: '李工' },
];

const statusMap: Record<string, any> = {
  pending: { color: 'default', text: '待处理' },
  processing: { color: 'processing', text: '处理中' },
  done: { color: 'success', text: '已完成' },
};

const priorityMap: Record<string, any> = {
  high: { color: 'red', text: '紧急' },
  normal: { color: 'blue', text: '普通' },
  low: { color: 'default', text: '低优先级' },
};

const WorkOrder: React.FC = () => {
  const [createVisible, setCreateVisible] = useState(false);
  const [form] = Form.useForm();

  return (
    <div style={{ padding: 16 }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        {[
          { title: '总工单', value: 128 }, { title: '待处理', value: 15, color: '#ff4d4f' },
          { title: '处理中', value: 23, color: '#faad14' }, { title: '已完成', value: 90, color: '#52c41a' },
        ].map((item, i) => (
          <Col span={6} key={i}>
            <Card bordered={false} style={{ borderRadius: 8 }}>
              <Statistic title={item.title} value={item.value} valueStyle={{ color: item.color || '#1890ff', fontWeight: 700 }} suffix="单" />
            </Card>
          </Col>
        ))}
      </Row>

      <Card
        title={<span><FileTextOutlined /> 工单列表</span>}
        extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => setCreateVisible(true)}>提交工单</Button>}
        bordered={false}
        style={{ borderRadius: 8 }}
      >
        <Table
          dataSource={orders}
          size="small"
          pagination={{ pageSize: 10 }}
          columns={[
            { title: '工单号', dataIndex: 'id', key: 'id', width: 100, render: v => <a>{v}</a> },
            { title: '标题', dataIndex: 'title', key: 'title' },
            { title: '客户', dataIndex: 'client', key: 'client', width: 140 },
            { title: '优先级', dataIndex: 'priority', key: 'priority', width: 90, render: (v: string) => <Tag color={priorityMap[v]?.color}>{priorityMap[v]?.text}</Tag> },
            { title: '状态', dataIndex: 'status', key: 'status', width: 90, render: (v: string) => <Badge status={statusMap[v]?.color} text={statusMap[v]?.text} /> },
            { title: '处理人', dataIndex: 'handler', key: 'handler', width: 80, render: v => v || '-' },
            { title: '提交时间', dataIndex: 'time', key: 'time', width: 160 },
            {
              title: '操作', key: 'action', width: 120,
              render: (_: any, r: any) => (
                <Space>
                  <Button size="small">查看</Button>
                  {r.status !== 'done' && <Button size="small" type="primary">处理</Button>}
                </Space>
              )
            },
          ]}
        />
      </Card>

      <Modal
        title="提交工单"
        open={createVisible}
        onCancel={() => setCreateVisible(false)}
        onOk={() => { form.validateFields().then(() => { message.success('工单提交成功！'); setCreateVisible(false); form.resetFields(); }); }}
        okText="提交"
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item label="工单标题" name="title" rules={[{ required: true }]}>
            <Input placeholder="请简要描述问题" />
          </Form.Item>
          <Form.Item label="工单类型" name="type" rules={[{ required: true }]}>
            <Select options={[
              { value: 'activation', label: '激活问题' }, { value: 'package', label: '套餐变更' },
              { value: 'esim', label: 'eSIM问题' }, { value: 'billing', label: '账单问题' }, { value: 'other', label: '其他' },
            ]} />
          </Form.Item>
          <Form.Item label="优先级" name="priority" initialValue="normal">
            <Select options={[{ value: 'high', label: '紧急' }, { value: 'normal', label: '普通' }, { value: 'low', label: '低' }]} />
          </Form.Item>
          <Form.Item label="问题描述" name="desc" rules={[{ required: true }]}>
            <Input.TextArea rows={4} placeholder="请详细描述问题..." />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default WorkOrder;
